import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAddingEventMemberQueryVariables = Types.Exact<{
  input: Types.GetAddingEventMemberInput;
}>;

export type GetAddingEventMemberQuery = {
  __typename?: 'Query';
  getAddingEventMember: {
    __typename?: 'GetAddingEventMemberResponse';
    items: Array<{
      __typename?: 'GetAddingEventMember';
      email: string;
      firstName: string;
      lastName: string;
      personUuid: string;
      statusName: string;
      roleName: string;
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetAddingEventMemberDocument = gql`
  query GetAddingEventMember($input: GetAddingEventMemberInput!) {
    getAddingEventMember(input: $input) {
      items {
        email
        firstName
        lastName
        personUuid
        statusName
        roleName
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetAddingEventMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAddingEventMemberQuery,
    GetAddingEventMemberQueryVariables
  > &
    (
      | { variables: GetAddingEventMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAddingEventMemberQuery,
    GetAddingEventMemberQueryVariables
  >(GetAddingEventMemberDocument, options);
}
export function useGetAddingEventMemberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAddingEventMemberQuery,
    GetAddingEventMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAddingEventMemberQuery,
    GetAddingEventMemberQueryVariables
  >(GetAddingEventMemberDocument, options);
}
export function useGetAddingEventMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAddingEventMemberQuery,
        GetAddingEventMemberQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAddingEventMemberQuery,
    GetAddingEventMemberQueryVariables
  >(GetAddingEventMemberDocument, options);
}
export type GetAddingEventMemberQueryHookResult = ReturnType<
  typeof useGetAddingEventMemberQuery
>;
export type GetAddingEventMemberLazyQueryHookResult = ReturnType<
  typeof useGetAddingEventMemberLazyQuery
>;
export type GetAddingEventMemberSuspenseQueryHookResult = ReturnType<
  typeof useGetAddingEventMemberSuspenseQuery
>;
export type GetAddingEventMemberQueryResult = Apollo.QueryResult<
  GetAddingEventMemberQuery,
  GetAddingEventMemberQueryVariables
>;
export function refetchGetAddingEventMemberQuery(
  variables: GetAddingEventMemberQueryVariables,
) {
  return { query: GetAddingEventMemberDocument, variables: variables };
}
